// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SliderVideo/BannerTwo.jpeg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Safety-pageWrapper-BfbVO {
  background-color: #ffffff;
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  width: 100%;
}

.Safety-heroSection-JNF3l {
  position: relative;
  width: 100%;
  min-height: 520px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center right;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.Safety-heroOverlay-_jJ1A {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(70deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.96) 24%,
      rgba(255, 255, 255, 0.7) 40%,
      rgba(255, 255, 255, 0) 70%);
  pointer-events: none;
  z-index: 1;
}

.Safety-heroContainer-mfYKE {
  margin: 0 auto;
  padding: 48px 5% 0 5%;
  width: 100%;
  position: relative;
  z-index: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.Safety-heroContent-B9XZ2 {
  max-width: 480px;
  padding-bottom: 60px;
}

.Safety-heroBadge-R5zwk {
  display: inline-block;
  font-family: var(--font-family-base) !important;
  font-size: 13px;
  font-weight: 700;
  color: var(--primary-color);
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.Safety-heroTitle-KmdRP {
  font-family: var(--font-family-primary) !important;
  font-size: 78px;
  font-weight: 800;
  color: var(--secondary-oscuro);
  line-height: 0.95;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0 0 16px 0;
}

.Safety-heroSubtitle-piSwc {
  font-family: var(--font-family-base) !important;
  font-size: 32px;
  font-weight: 700;
  color: var(--secondary-oscuro);
  line-height: 1.22;
  margin: 0 0 16px 0;
}

.Safety-heroDescription-TXI_0 {
  font-family: var(--font-family-base) !important;
  font-size: 15px;
  color: #475569;
  line-height: 1.55;
  margin: 0;
  max-width: 420px;
}

.Safety-heroDescription-TXI_0 strong {
  color: var(--secondary-oscuro);
  font-weight: 700;
}

.Safety-multiline-Ak3G2 {
  white-space: pre-line;
}

.Safety-heroMascotWrapper-f_5ZL {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin-right: 3%;
  margin-top: 105px;
}

.Safety-heroMascot-IlXVp {
  width: 370px;
  max-width: 100%;
  height: auto;
  display: block;
}

.Safety-featuresSection-s7N6Y {
  padding: 60px 8% 44px 8%;
  background-color: #ffffff;
  width: 100%;
}

.Safety-featuresGrid-dppv1 {
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding: 0 4%;
  width: 100%;
}

.Safety-featureCard-z9_cc {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  text-align: center;
  padding: 8px 12px;
}

.Safety-featureIconBox-ssB9w {
  width: 78px;
  height: 78px;
  border-radius: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 16px;
}

.Safety-featureIconBlue-_9oyG {
  background-color: #e1f4fe;
  color: var(--primary-color);
}

.Safety-featureIconGreen-W1Bmj {
  background-color: #e0fbf2;
  color: var(--secondary-esmeralda);
}

.Safety-featureIconImage-b5aOY {
  width: 30px;
  height: 30px;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
}

.Safety-featureTitle-uETz9 {
  font-family: var(--font-family-base) !important;
  font-size: 19px;
  font-weight: 700;
  color: var(--secondary-oscuro);
  margin: 0 0 6px 0;
}

.Safety-featureDescription-VW8Oq {
  font-family: var(--font-family-base) !important;
  font-size: 15px;
  color: #5d6f83;
  line-height: 1.45;
  margin: 0;
}

.Safety-bottomCardSection-PN6gk {
  padding: 16px 5% 80px 5%;
  background-color: #ffffff;
  width: 100%;
}

.Safety-bottomCard-Oiurm {
  margin: 0 auto;
  background: linear-gradient(135deg, #eef7fc 0%, #e2f1fa 100%);
  border-radius: 24px;
  padding: 48px 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 48px;
  overflow: hidden;
  -webkit-box-shadow: 0 8px 30px rgba(0, 52, 83, 0.04);
          box-shadow: 0 8px 30px rgba(0, 52, 83, 0.04);
  width: 100%;
}

.Safety-bottomCardContent-jfBGY {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  max-width: 560px;
}

.Safety-bottomCardTitle-aqEHy {
  font-family: var(--font-family-primary) !important;
  font-size: 42px;
  font-weight: 700;
  color: var(--secondary-oscuro);
  line-height: 1.15;
  letter-spacing: 0.3px;
  margin: 0 0 18px 0;
}

.Safety-bottomCardText-_0UJ4 {
  font-family: var(--font-family-base) !important;
  font-size: 15px;
  color: #4a607a;
  line-height: 1.6;
  margin: 0;
}

.Safety-bottomCardMascotWrapper-NTRwJ {
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.Safety-bottomCardMascot-FmUyf {
  width: 330px;
  max-width: 100%;
  height: auto;
  display: block;
  -webkit-filter: drop-shadow(0 10px 28px #abe4ff) drop-shadow(0 0 40px rgba(171, 228, 255, 0.85));
          filter: drop-shadow(0 10px 28px #abe4ff) drop-shadow(0 0 40px rgba(171, 228, 255, 0.85));
}

@media (max-width: 991px) {
  .Safety-heroSection-JNF3l {
    min-height: auto;
    padding-top: 20px;
  }

  .Safety-heroOverlay-_jJ1A {
    background: -webkit-gradient(linear,
        left top, left bottom,
        from(rgba(255, 255, 255, 0.94)),
        color-stop(60%, rgba(255, 255, 255, 0.88)),
        to(rgba(255, 255, 255, 0.7)));
    background: linear-gradient(180deg,
        rgba(255, 255, 255, 0.94) 0%,
        rgba(255, 255, 255, 0.88) 60%,
        rgba(255, 255, 255, 0.7) 100%);
  }

  .Safety-heroContainer-mfYKE {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
    padding: 32px 24px 20px 24px;
  }

  .Safety-heroContent-B9XZ2 {
    max-width: 100%;
    padding-bottom: 24px;
  }

  .Safety-heroTitle-KmdRP {
    font-size: 60px;
  }

  .Safety-heroSubtitle-piSwc {
    font-size: 26px;
  }

  .Safety-heroDescription-TXI_0 {
    margin: 0 auto;
  }

  .Safety-heroMascotWrapper-f_5ZL {
    margin-right: 0;
  }

  .Safety-heroMascot-IlXVp {
    width: 290px;
  }

  .Safety-featuresSection-s7N6Y {
    padding: 48px 24px 32px 24px;
  }

  .Safety-featuresGrid-dppv1 {
    padding: 0;
    gap: 28px;
  }

  .Safety-bottomCardSection-PN6gk {
    padding: 16px 20px 60px 20px;
  }

  .Safety-bottomCard-Oiurm {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    padding: 36px 28px;
    text-align: center;
    gap: 28px;
  }

  .Safety-bottomCardContent-jfBGY {
    max-width: 100%;
  }

  .Safety-bottomCardTitle-aqEHy {
    font-size: 32px;
  }

  .Safety-bottomCardMascot-FmUyf {
    width: 260px;
  }
}

@media (max-width: 767px) {
  .Safety-featuresGrid-dppv1 {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .Safety-heroTitle-KmdRP {
    font-size: 48px;
  }

  .Safety-heroSubtitle-piSwc {
    font-size: 22px;
  }

  .Safety-bottomCardTitle-aqEHy {
    font-size: 26px;
  }

  .Safety-bottomCard-Oiurm {
    padding: 28px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/safety/Safety.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yDAAmE;EACnE,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;iCAI+B;EAC/B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAc;MAAd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oDAA4C;UAA5C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAc;MAAd,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gGAAwF;UAAxF,wFAAwF;AAC1F;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE;;;;qCAGkC;IAHlC;;;sCAGkC;EACpC;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".pageWrapper {\n  background-color: #ffffff;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.heroSection {\n  position: relative;\n  width: 100%;\n  min-height: 520px;\n  background-image: url('../../../public/SliderVideo/BannerTwo.jpeg');\n  background-size: cover;\n  background-position: center right;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n.heroOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(70deg,\n      #ffffff 0%,\n      rgba(255, 255, 255, 0.96) 24%,\n      rgba(255, 255, 255, 0.7) 40%,\n      rgba(255, 255, 255, 0) 70%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.heroContainer {\n  margin: 0 auto;\n  padding: 48px 5% 0 5%;\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n\n.heroContent {\n  max-width: 480px;\n  padding-bottom: 60px;\n}\n\n.heroBadge {\n  display: inline-block;\n  font-family: var(--font-family-base) !important;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--primary-color);\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n\n.heroTitle {\n  font-family: var(--font-family-primary) !important;\n  font-size: 78px;\n  font-weight: 800;\n  color: var(--secondary-oscuro);\n  line-height: 0.95;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin: 0 0 16px 0;\n}\n\n.heroSubtitle {\n  font-family: var(--font-family-base) !important;\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--secondary-oscuro);\n  line-height: 1.22;\n  margin: 0 0 16px 0;\n}\n\n.heroDescription {\n  font-family: var(--font-family-base) !important;\n  font-size: 15px;\n  color: #475569;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 420px;\n}\n\n.heroDescription strong {\n  color: var(--secondary-oscuro);\n  font-weight: 700;\n}\n\n.multiline {\n  white-space: pre-line;\n}\n\n.heroMascotWrapper {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-right: 3%;\n  margin-top: 105px;\n}\n\n.heroMascot {\n  width: 370px;\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.featuresSection {\n  padding: 60px 8% 44px 8%;\n  background-color: #ffffff;\n  width: 100%;\n}\n\n.featuresGrid {\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  padding: 0 4%;\n  width: 100%;\n}\n\n.featureCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 8px 12px;\n}\n\n.featureIconBox {\n  width: 78px;\n  height: 78px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.featureIconBlue {\n  background-color: #e1f4fe;\n  color: var(--primary-color);\n}\n\n.featureIconGreen {\n  background-color: #e0fbf2;\n  color: var(--secondary-esmeralda);\n}\n\n.featureIconImage {\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n  display: block;\n}\n\n.featureTitle {\n  font-family: var(--font-family-base) !important;\n  font-size: 19px;\n  font-weight: 700;\n  color: var(--secondary-oscuro);\n  margin: 0 0 6px 0;\n}\n\n.featureDescription {\n  font-family: var(--font-family-base) !important;\n  font-size: 15px;\n  color: #5d6f83;\n  line-height: 1.45;\n  margin: 0;\n}\n\n.bottomCardSection {\n  padding: 16px 5% 80px 5%;\n  background-color: #ffffff;\n  width: 100%;\n}\n\n.bottomCard {\n  margin: 0 auto;\n  background: linear-gradient(135deg, #eef7fc 0%, #e2f1fa 100%);\n  border-radius: 24px;\n  padding: 48px 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 48px;\n  overflow: hidden;\n  box-shadow: 0 8px 30px rgba(0, 52, 83, 0.04);\n  width: 100%;\n}\n\n.bottomCardContent {\n  flex: 1;\n  max-width: 560px;\n}\n\n.bottomCardTitle {\n  font-family: var(--font-family-primary) !important;\n  font-size: 42px;\n  font-weight: 700;\n  color: var(--secondary-oscuro);\n  line-height: 1.15;\n  letter-spacing: 0.3px;\n  margin: 0 0 18px 0;\n}\n\n.bottomCardText {\n  font-family: var(--font-family-base) !important;\n  font-size: 15px;\n  color: #4a607a;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.bottomCardMascotWrapper {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bottomCardMascot {\n  width: 330px;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  filter: drop-shadow(0 10px 28px #abe4ff) drop-shadow(0 0 40px rgba(171, 228, 255, 0.85));\n}\n\n@media (max-width: 991px) {\n  .heroSection {\n    min-height: auto;\n    padding-top: 20px;\n  }\n\n  .heroOverlay {\n    background: linear-gradient(180deg,\n        rgba(255, 255, 255, 0.94) 0%,\n        rgba(255, 255, 255, 0.88) 60%,\n        rgba(255, 255, 255, 0.7) 100%);\n  }\n\n  .heroContainer {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 32px 24px 20px 24px;\n  }\n\n  .heroContent {\n    max-width: 100%;\n    padding-bottom: 24px;\n  }\n\n  .heroTitle {\n    font-size: 60px;\n  }\n\n  .heroSubtitle {\n    font-size: 26px;\n  }\n\n  .heroDescription {\n    margin: 0 auto;\n  }\n\n  .heroMascotWrapper {\n    margin-right: 0;\n  }\n\n  .heroMascot {\n    width: 290px;\n  }\n\n  .featuresSection {\n    padding: 48px 24px 32px 24px;\n  }\n\n  .featuresGrid {\n    padding: 0;\n    gap: 28px;\n  }\n\n  .bottomCardSection {\n    padding: 16px 20px 60px 20px;\n  }\n\n  .bottomCard {\n    flex-direction: column;\n    padding: 36px 28px;\n    text-align: center;\n    gap: 28px;\n  }\n\n  .bottomCardContent {\n    max-width: 100%;\n  }\n\n  .bottomCardTitle {\n    font-size: 32px;\n  }\n\n  .bottomCardMascot {\n    width: 260px;\n  }\n}\n\n@media (max-width: 767px) {\n  .featuresGrid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .heroTitle {\n    font-size: 48px;\n  }\n\n  .heroSubtitle {\n    font-size: 22px;\n  }\n\n  .bottomCardTitle {\n    font-size: 26px;\n  }\n\n  .bottomCard {\n    padding: 28px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `Safety-pageWrapper-BfbVO`,
	"heroSection": `Safety-heroSection-JNF3l`,
	"heroOverlay": `Safety-heroOverlay-_jJ1A`,
	"heroContainer": `Safety-heroContainer-mfYKE`,
	"heroContent": `Safety-heroContent-B9XZ2`,
	"heroBadge": `Safety-heroBadge-R5zwk`,
	"heroTitle": `Safety-heroTitle-KmdRP`,
	"heroSubtitle": `Safety-heroSubtitle-piSwc`,
	"heroDescription": `Safety-heroDescription-TXI_0`,
	"multiline": `Safety-multiline-Ak3G2`,
	"heroMascotWrapper": `Safety-heroMascotWrapper-f_5ZL`,
	"heroMascot": `Safety-heroMascot-IlXVp`,
	"featuresSection": `Safety-featuresSection-s7N6Y`,
	"featuresGrid": `Safety-featuresGrid-dppv1`,
	"featureCard": `Safety-featureCard-z9_cc`,
	"featureIconBox": `Safety-featureIconBox-ssB9w`,
	"featureIconBlue": `Safety-featureIconBlue-_9oyG`,
	"featureIconGreen": `Safety-featureIconGreen-W1Bmj`,
	"featureIconImage": `Safety-featureIconImage-b5aOY`,
	"featureTitle": `Safety-featureTitle-uETz9`,
	"featureDescription": `Safety-featureDescription-VW8Oq`,
	"bottomCardSection": `Safety-bottomCardSection-PN6gk`,
	"bottomCard": `Safety-bottomCard-Oiurm`,
	"bottomCardContent": `Safety-bottomCardContent-jfBGY`,
	"bottomCardTitle": `Safety-bottomCardTitle-aqEHy`,
	"bottomCardText": `Safety-bottomCardText-_0UJ4`,
	"bottomCardMascotWrapper": `Safety-bottomCardMascotWrapper-NTRwJ`,
	"bottomCardMascot": `Safety-bottomCardMascot-FmUyf`
};
module.exports = ___CSS_LOADER_EXPORT___;
